import React from "react";

import Page from "../../../layout/web/Page";
import Title from "../../../components/Common/Title";
import Connector from "../../../redux/connector";

import {PostToPbx} from "../../../api/http-post";
import {
    Switch,
    PageHeader,
    Descriptions
} from "antd";
import {PhoneFilled} from '@ant-design/icons';
import {GetUserToken} from "../../../api/token";
import CloudCall, {doHangup, answer, sendDtmf, doCall} from "../../../webcall/JanusSipCall";
import AlertBox from "../../../webcall/AlertBox";
import moment from "moment";
import {Tabs, Select, Space,Input} from 'antd';

const {TabPane} = Tabs;

const {Search} = Input;

const currentDate = moment().format("YYYY-MM-DD");
let userN = GetUserToken();

class WorkboardCallcenterOutboundPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Modules: [],
            Stages: [],
            isLoading: false,
            component: "list",
            selectedCompany:"",
            selectedEntity:"",
            newCommentBody: "",
            newCommentCategory: "",
            CategoryComments: [],
            LeadRequest: null,
            currentOrg: userN.Org,
            currentAgent: userN.Username,
            currentAgentName: userN.FullName,
            currentRole: "super",
            inRef: "",
            inPool: "",
            LeadComments: [],
            Dispositions: [],
            Extensions: [],
            newEntry: {
                disposition: "",
                comment: "",
            },
            dialingNumber: "",
            startDate: currentDate,
            endDate: currentDate,
            newLeadEntry: {
                name: "",
                surname: "",
                phone: "",
                email: "",
                comment: "",
            },
            showNewLeadList: true,
            LeadCallLogs: [],
            LeadStatusLogs: [],
            DashboardAgents: null
        }
    }

    componentDidMount = async () => {

        await this.loadInitialData()
    }

    loadInitialData = async () => {
        await this.loadData("Stages","Stages");
        /*

        await this.loadData("product","Products")
        */
    }
    loadData = async (targetEntity, stateKey) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            console.log("SettingSetupSitePage loadInitialData response > ", post, " > ", data);
            let res=[];
            if(data!==null){
                res=data.RESULT
            }
            await _this.setState({
                [stateKey]: res
            })
        });
    }
    PostState = async (hub, endpoint, stateKey) => {
        let _this = this;
        this.setState({
            isLoading: true
        })
        await PostToPbx(hub, endpoint, async (dataIn) => {
            if(dataIn===null){
                _this.setState({
                    [stateKey]: [],
                    isLoading: false
                })
                return
            }
            const data = dataIn.RESULT;

            console.log(endpoint + " response ---> ", data, dataIn);
            _this.setState({
                [stateKey]: data,
                isLoading: false
            })
        });
    }
    submitCallLog = async (phone, ref) => {
        let hub = {
            Org: this.state.currentOrg,
            Agent: this.state.currentAgent,
            Ref: "admin-outbound",
            Phone: phone,
            CallRef: this.props.pbx.Extension.username
        }
        let endpoint = "/lead/entity/insert/batch-agent-call";
        await this.PostState(hub, endpoint, "fakeCallLogSubmit");
    }
    dialRequest = async (phone) => {
        console.log("dialRequest--> ", phone);
        const regStatus = this.props.pbx.Registry.status;
        if (regStatus === "Not registered") {
            return alert("Sorry you can't make without register first, click on the online switch!")
        }

        if (this.state.isDialing) {
            return alert("Please wait while another call in progress!");
        }
        if (phone === "") {
            return alert("Please provide number to call!");
        }
        if (!this.isValidNumber(phone)) {
            return alert("Error your number is not valid! 10 digit required")
        }
        let destination = "27" + phone.substring(phone.length - 9);
        //destination = destination.substring(destination.length - 9);

        doCall({
            to: destination,
            host: this.props.pbx.Server.host,
            AlertBox: AlertBox,
            isVideoCall: false
        });
        //this.props.PbxOutCallShowForm({isSet:true})
        this.setState({
            dialingNumber: phone
        });

        await this.submitCallLog(phone)

    }
    stop = () => {
        doHangup();
        this.props.PbxOutCallEnd({is: true})
    }
    isValidNumber = (num) => {
        let str = num;
        let pattern = new RegExp("^[0-9]{10}$");
        let result = pattern.test(str);
        console.log("isValidNumber -> ", str, " > ", result, " > ", /^\d{10}$/.test(str));
        return true
    }
    renderHangup = () => {
        let props = this.props;
        let pbxCalling = props.pbx.Calling;
        let dialStatus = false;
        if (pbxCalling.status !== "Not registered") {
            dialStatus = true
        }

        let _this = this;
        if (pbxCalling.status === "Not registered" || pbxCalling.status === "hangup") {
            return null
        }
        return (
            <a
                style={{cursor: "pointer", color: "red", marginLeft: 20}}
                onClick={() => _this.stop()}
            >
                <PhoneFilled/>
            </a>
        )
    }


    render() {
        let props = this.props;
        let pbxCalling = props.pbx.Calling;
        let dialStatus = false;
        if (pbxCalling.status !== "Not registered") {
            dialStatus = true
        }
        const regStatus = this.props.pbx.Registry.status;
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title={"Click to  Dial (Admin)".toLocaleUpperCase()}
                        subTitle="context reserved for admin user outside of lead"
                        extra={[
                            <div style={{marginRight: 10, minWidth: "100%", paddingLeft: 20}}>
                                &nbsp;Extension: {this.props.pbx.Extension.username}

                                <span style={{float: "right"}}>
                                        Reg.Status:
                                        <span style={{
                                            backgroundColor: regStatus === "Not registered" ? 'orange' : 'green',
                                            color: "white",
                                            borderRadius: 8,
                                            padding: 5,
                                            marginLeft: 5
                                        }}>{regStatus}</span>

                                    </span>
                            </div>,
                        ]}
                        style={{border: "1px solid rgb(235, 237, 240)"}}
                    >
                        <Descriptions size="small" column={3}>
                            <Descriptions.Item label="Full name">{userN.Fullname}</Descriptions.Item>
                            <Descriptions.Item label="Role">
                                <a>{userN.Role}</a>
                            </Descriptions.Item>
                            <Descriptions.Item label="Creation Time">{userN.OrgDateTime}</Descriptions.Item>
                            <Descriptions.Item label="Username">{userN.Username}</Descriptions.Item>
                            <Descriptions.Item label="Status">
                                {userN.Status}
                            </Descriptions.Item>
                        </Descriptions>
                    </PageHeader>

                    <div style={styles.containerBox}>
                        <Tabs tabPosition={this.state.tabPosition} style={{
                            backgroundColor: "white",
                            minHeight: 400,
                            padding: "30px",
                            marginTop: 20,
                        }}>
                            <TabPane tab={"Click to Dial"} key="1">
                                <div>
                                    {dialStatus ?
                                        <React.Fragment>
                                                <span
                                                    style={{color: "#9c27b0",fontSize:24}}
                                                >
                                                    Call Status :{pbxCalling.status} {this.renderHangup()}
                                                </span>
                                        </React.Fragment> : null}
                                </div>
                                <div style={{display: "flex", flexDirection: "row", flex: 1,}}>
                                    <div style={{maxWidth: "95%", minWidth: "95%", minHeight: 35, maxHeight: 35}}>
                                        <Search
                                            placeholder="input phone number"
                                            enterButton="Dial"
                                            size="large"
                                            onSearch={value => this.dialRequest(value)}
                                            style={{
                                                minHeight: 35,
                                                maxHeight: 35
                                            }}
                                        />
                                    </div>
                                    <div style={{
                                        maxWidth: "5%",
                                        minWidth: "5%",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        minHeight: 35,
                                        maxHeight: 35,
                                    }}>
                                        {/*<Button
                                                type={"danger"}
                                                style={{
                                                    minHeight: 35,
                                                    maxHeight: 35,
                                                    marginLeft: 10,
                                                    marginTop: 5
                                                }}
                                            >Hangup</Button>*/}
                                    </div>
                                </div>


                            </TabPane>

                        </Tabs>
                    </div>

                </div>
            </Page>
        )
    }

}


export default Connector(WorkboardCallcenterOutboundPage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    },
    card: {
        minHeight: 400,
    },
    containerBox: {
        background: "#ececec",
        padding: "30px",
        marginTop: 20,
        minHeight: 400,
    },
    box: {
        minHeight: 400,
        margin: 10
    },

}
